import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/browserTools'; // 引入 MCP browser tools

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// 在控制台输出提示信息
console.log('%c MCP Browser Tools 已激活! 🛠️', 'background: #006847; color: white; padding: 5px; border-radius: 3px; font-weight: bold;');
console.log('可用命令: MCPBrowserTools.runSEOAudit(), MCPBrowserTools.runDebuggerMode(), MCPBrowserTools.takeScreenshot()');
